module.exports = __webpack_public_path__ + "img/logo-tolusimmo.3b461f5b.svg";